import React, { useState } from 'react';
import Modal from 'react-modal';


import FormInput from '../forms/FormInput';
import api from '../../api/api';
import uri from '../../variables/uri';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const GroupModal = ({ isOpen, onClose, onSuccess }) => {
    const [group, setGroupName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onGroupNameChange = (value) => {
        setGroupName(value);
    }

    const handleCheckboxChange = (e) =>{
        setActive(e.target.checked);
    }
    const onSubmit = async () => {
        setIsLoading(true);
        try {
            const response = await api.post(`${uri.POST_UPDATE_GROUP}`,{
                Name: group,
                Active: active
            });
            if(response.status === 200) {
                onClose();
                onSuccess();
            };
        } catch (ex) {
            setErrorMessage(ex.Message)
            setIsLoading(false);
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={!isLoading ? onClose : () => { }}
            style={customStyles}
            contentLabel="Message">
            <div>
                <div style={{ minWidth: '300px' }} className="flex-h flex-between">
                    <div>
                        <h1 className="f-200">New Group</h1>
                    </div>
                </div>
                <div className="mt-16 mb-16" style={{ border: '1px solid #ddd', borderRadius: '20px' }}></div>
                <FormInput
                    name="Group name"
                    value={group}
                    onValueChange={onGroupNameChange}
                    readonly={isLoading} />
                <div className="flex-v mt-16">
                    <label className="font-12">Active: <input className="ml-8 button-edit-small" onChange={(e) => handleCheckboxChange(e)} type="checkbox" checked={active} /></label>
                </div>
                
                <h3 className="has-text-danger mt-24 has-text-centered">{errorMessage}</h3>
                <button disabled={group === ''} onClick={() => onSubmit()} className={`mt-24 button is-success is-fullwidth center ${isLoading && 'is-loading'}`}>Save</button>
            </div>
        </Modal>
    );
}



export default GroupModal;